var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.22.434a.75.75 0 01.984-.067l.076.067L4.816 3.97a.75.75 0 01.067.984l-.067.076L1.28 8.566a.75.75 0 01-1.127-.984l.067-.077L3.225 4.5.22 1.495A.75.75 0 01.153.51L.22.434z","fill":"#AAA"}));
}

Arrow.defaultProps = {"width":"5","height":"9"};

module.exports = Arrow;

Arrow.default = Arrow;
